import { Icon } from "@iconify/react";

interface FileTypeIconProps {
  icon: string;
  className?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

/**
 * Renders a file type icon — supports both Iconify icon names and local SVG paths.
 * SVG paths (starting with "/") render as <img>, everything else as <Icon>.
 */
export const FileTypeIcon: React.FC<FileTypeIconProps> = ({
  icon,
  className,
  width,
  height,
  style,
}) => {
  if (icon.startsWith("/")) {
    return (
      <img alt="" className={className} height={height} src={icon} style={style} width={width} />
    );
  }

  return <Icon className={className} height={height} icon={icon} style={style} width={width} />;
};
